<template>
  <div v-loading="loading">
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row class="text-left">
      <el-input v-model="id" placeholder="请输入会员id，可输入多个，中间用英文逗号隔开，必须保证为同一地区客户" size="mini"
                style="width:500px"></el-input>
      <el-button @click="getMemberInfo" class="margin-left" size="mini">查询会员信息</el-button>
      <el-button class="margin-left" @click="checkMapMember" size="mini" v-if="selectCompany.length>0">查询状态</el-button>
      <el-button class="margin-left" @click="buyMapMember" size="mini" v-if="selectCompany.length>0">购买</el-button>
      <el-button class="margin-left" @click="getPayUrl" size="mini">查询未支付订单</el-button>
    </el-row>
    <el-table :data="list" row-key="memberId" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="公司名称" prop="company" width="300"></el-table-column>
      <el-table-column label="会员id" prop="memberId" width="100"></el-table-column>
      <el-table-column label="信用代码" prop="unified_code" width="200"></el-table-column>
      <el-table-column label="所在省份" prop="province" width="80"></el-table-column>
      <el-table-column label="所在城市" prop="city" width="80"></el-table-column>
      <el-table-column label="地址" prop="address"></el-table-column>
      <el-table-column label="操作" width="100">
        <template v-slot="scope">
          <el-button v-if="scope.row.address===''" @click="setAddress(scope)" type="text">设置地址</el-button>
        </template>
      </el-table-column>
    </el-table>
<!--    <el-dialog :visible.sync="payUrlDiv" v-if="payUrlDiv" :close-on-click-modal="false" :title="crntCompany.row.company">-->
<!--      {{payUrl}}-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button type="primary" @click="payUrlDiv = false">关 闭</el-button>-->
<!--        <el-button type="primary" @click="pay">去支付</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->
        <el-dialog :visible.sync="payUrlDiv" width="80%" :close-on-click-modal="false" @close="notice=''">
          <div class="text-left">
            <div v-for="(item,index) in payUrl" :key="index" class=" margin-large-bottom">
              <h1 style="margin-bottom:10px">{{item.area_text}}<span style="color:red;margin-left:10px">{{notice}}</span></h1>
              <div v-if="item.data.length>0">
                <span v-for="(it,id) in item.data" :key="id" style="display: inline-block;border-radius: 10px;margin:10px 5px;padding:10px 20px;border:1px solid #E5E5E5">{{it.company}}</span>
              </div>
              <div v-else>无待支付订单</div>
              <div v-if="item.pay != ''" class="margin-top">
                <el-button size="mini" type="success" @click="pay(item.pay)">支付</el-button>
                <el-button size="mini" type="danger" @click="cancel(item)">取消订单</el-button>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="payUrlDiv = false">关 闭</el-button>
          </span>
        </el-dialog>
    <el-dialog :visible.sync="mdfyDiv" v-if="mdfyDiv" :close-on-click-modal="false" :title="crntCompany.row.company">
      <el-input v-model="address" placeholder="请输入公司详细地址"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mdfyDiv = false">关 闭</el-button>
        <el-button type="primary" @click="subAddress">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: '',
      loading: false,
      payUrlDiv: false,
      payUrl: [],
      notice: '',
      list: [],
      mdfyDiv: false,
      crntCompany: '',
      address: '',
      selectCompany:[]
    }
  },
  methods: {
    showLoading() {
      this.loading = true;
    },
    buyMapMember() {
      if (this.selectCompany.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择要购买联合会员的公司'
        })
        return;
      }
      this.showLoading()
      this.$axios({
        url: this.HOST + '/admin.mapmember/buyMapmember',
        method: 'post',
        data: {
          memberList: this.selectCompany,
        }
      }).then(res => {
        this.loading = false
        if (res.data.status === 1) {
          this.payUrl = res.data.result;
          this.notice = res.data.notice;
          this.payUrlDiv = true;
        }
      })
    },
    getPayUrl() {
      this.showLoading()
      this.$axios({
        url: this.HOST + '/admin.index/getPayUrl',
        method: 'post',
      }).then(res => {
        this.loading = false
        if (res.data.status === 1) {
          this.payUrl = res.data.result;
          this.payUrlDiv = true;
        }
      })
    },
    pay(url) {
      window.open(url, '_blank');
      this.payUrlDiv = false;
    },
    cancel(item) {
      this.$confirm(`确定要取消${item.area_text}地区的智能体订单吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          url: this.HOST + "/admin.mapmember/cancelOrder",
          method: "post",
          data: {
            area: item.area
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.payUrlDiv = false;
          }
        });
      });
    },
    checkMapMember() {
      this.$axios({
        url: this.HOST + '/admin.mapmember/checkMapMemberStatus',
        method: 'post',
        data: {
          member_id: this.id,
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.status === 1) {

        }
      })
    },
    getMemberInfo() {
      if (this.id === '') {
        this.$message({
          type: 'error',
          message: '请输入会员id'
        })
        return;
      }
      this.$axios({
        url: this.HOST + '/admin.mapmember/getMemberInfo',
        method: 'post',
        data: {
          member_id: this.id,
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.list = res.data.list;
        }
      })
    },
    setAddress(scope) {
      this.crntCompany = scope;
      this.mdfyDiv = true;
    },
    subAddress() {
      this.$axios({
        url: this.HOST + '/admin.mapmember/saveAddress',
        method: 'post',
        data: {
          member_id: this.crntCompany.row.memberId,
          address: this.address,
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.crntCompany.row.address = this.address;
          this.mdfyDiv = false;
        }
      })
    },
    handleSelectionChange(e){
      this.selectCompany = e;
    }
  },
  mounted() {
  }
}
</script>